const REPLACE_MAP = {
    // standard digits (note: this is an optimization, handling standard and
    // nonstandard numbers in one operation)
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    '-': '-',
    '.': '.',
    // intentional: handle commas as decimals
    ',': '.',
    // Persian
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    // eastern arabic
    '،': '.',
    '٫': '.',
    '٬': '.',
    '٠': '0',
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
};

export { REPLACE_MAP };
//# sourceMappingURL=formatter.constants.js.map
